import CaseStudyCard from "../../reusables/CaseStudyCard";
import arasus from "../../../assets/images/case-studies/arasus.jpg";

const ArasusCaseStudyCard = () => {
  return (
    <CaseStudyCard
      brand={arasus}
      client="Arasus Aviation"
      solution="Website Re-design"
      title="Complete digital setup of a new aviation company entering Ugandan market"
      subtitle="The company needed a high-perfoming website with payment integration, and a full digital setup"
      link="/case-studies/arasus"
    >
      <li>
        ✔︎ <span>Website re-design</span>
      </li>
      <li>
        ✔︎ <span>Social media setup</span>
      </li>
      <li>
        ✔︎ <span>Social media ads</span>
      </li>
      <li>
        ✔︎ <span>Management system</span>
      </li>
      <li>
        ✔︎ <span>CCTV Installation</span>
      </li>
    </CaseStudyCard>
  );
};

export default ArasusCaseStudyCard;
